import { render, staticRenderFns } from "./SocialLinks.vue?vue&type=template&id=7280b952&scoped=true"
var script = {}
import style0 from "./SocialLinks.vue?vue&type=style&index=0&id=7280b952&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7280b952",
  null
  
)

export default component.exports